import { Typography, TypographyProps } from '@mui/material';
import styles from './PageTitle.styles';

interface PageTitleComponentProps extends TypographyProps {
  title: string;
}

const PageTitleComponent = function ({ title, sx, ...rest }: PageTitleComponentProps): JSX.Element {
  const style = Object.assign(styles, sx);

  return (
    <Typography variant="h3" fontWeight="bold" color="primary" sx={style} {...rest}>
      {title}
    </Typography>
  );
};

export default PageTitleComponent;
